import { t } from "i18next";
import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";

export default function Legal(){

    const location = useLocation();
    const path = location.pathname.substr(1);

    // const navigate = 
    useEffect(()=>{
        // const _id = this.props.lang==='fr-CA' ? fr_id : en_id;
        const id = t(path+'.id');
      eval(`OneTrust.NoticeApi.LoadNotices(["https://privacyportalde-cdn.onetrust.com/f69c0bf1-10ab-4d33-8b59-e235ddd37a5f/privacy-notices/${id}.json"])`);
    },[path]);

    return (
        <Container fluid as='main' className="rules">
            <Row>
                <Col className="text-sm-center">
                    <h1>{t(path+'.title')}</h1>
                </Col>
            </Row>
            <Row className="skinny-row">
                {path==='cookies'
                    ? <Col dangerouslySetInnerHTML={{__html:t(path+'.content')}} />
                    : <Col>
                        <div id={`otnotice-${t(path+'.id')}`} className="otnotice"></div>
                      </Col>
                    }
                
            </Row>
        </Container>
    );
}